/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSsoProviderCompanyMappingFromJSON, StreemApiSsoProviderCompanyMappingToJSON, } from './';
export function StreemApiListSsoProviderCompanyMappingsResponseFromJSON(json) {
    return StreemApiListSsoProviderCompanyMappingsResponseFromJSONTyped(json, false);
}
export function StreemApiListSsoProviderCompanyMappingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ssoProviderCompanyMappings': !exists(json, 'sso_provider_company_mappings') ? undefined : (json['sso_provider_company_mappings'].map(StreemApiSsoProviderCompanyMappingFromJSON)),
    };
}
export function StreemApiListSsoProviderCompanyMappingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sso_provider_company_mappings': value.ssoProviderCompanyMappings === undefined ? undefined : (value.ssoProviderCompanyMappings.map(StreemApiSsoProviderCompanyMappingToJSON)),
    };
}
//# sourceMappingURL=StreemApiListSsoProviderCompanyMappingsResponse.js.map